import { ManualPulseRequest, ManualActionState } from "./types";

export function getDefaultState(): ManualActionState {
    return {
        manualPulseData: {
            deviceId: 0,
            reason: ""
        },
        manualEventResetData: {
            responseId: 0,
            groupId: 0,
            serverId: 0,
            cCureEventID: 0,
            reason: ""
        },
    };
}